import { getJSDate } from "../../utilities/general"

const ratings = {
    Behind: { bgColor: "bg-light-danger", color: "text-danger" },
    "On-Schedule": { bgColor: "bg-light-primary", color: "text-primary" },
    Ahead: { bgColor: "bg-light-success", color: "text-success" },
}

const outdatedProgressReport = (report) => {
    if (!report) {
        return true
    }

    const now = new Date()
    const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())

    const reportDate = getJSDate(report.created_at)
    const reportDateUTC = Date.UTC(reportDate.getUTCFullYear(), reportDate.getUTCMonth(), reportDate.getUTCDate())

    const delta = (today - reportDateUTC) / (1000 * 60 * 60 * 24)

    return delta > 7
}

export const ProgressRating = ({report, outdatedWarning, variant = "default"}) => {
    const rating = ratings[report?.rating_name]

    const isNotSummaryView = variant === "summary"

    return (
        <span className="d-flex align-items-center gap-2 fs-5">
            <span
                className={`text-dark fw-bold ${
                    isNotSummaryView ? "fs-5" : "fs-7"
                }`}
            >
                Progress Rating:
            </span>

            {rating ? (
                <span
                    className={`badge flex-center px-4 py-2 ${rating.bgColor} ${rating.color}`}
                >
                    {outdatedWarning && outdatedProgressReport(report) ? (
                        <i
                            className="fas fa-exclamation-triangle text-danger me-1"
                            title="This Progress Status is out of date. Please review orientee progress and complete a new status report"
                            data-testid="outdated-warning"
                        />
                    ) : null}
                    {report.rating_name}
                </span>
            ) : (
                <span
                    className={isNotSummaryView ? "badge badge-lg badge-light-danger ms-2 px-6 py-2 fs-7" : "badge badge-sm badge-light-danger ms-2"}
                >
                    <i className="fas fa-exclamation-triangle text-danger me-2" />
                    Incomplete
                </span>
            )}
        </span>
    )
}